// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"42ad58de","692":"4806f947","795":"83246b35"}[chunkId] + ".chunk.js";
};